import { CouponItem } from './coupon-item';
import { ExpiredCouponItem } from './expired-coupon-item';
import styles from './coupon-list.module.sass';

export const CouponList = ({ coupons, type = 'available' }) => {
  return (
    <div className={styles.root}>
      {coupons.map(coupon => {
        switch (type) {
          case 'available':
            return <CouponItem key={coupon.id} coupon={coupon} />;
          case 'expired':
            return <ExpiredCouponItem key={coupon.id} coupon={coupon} />;
          default:
            throw new Error('CouponList: invalid type');
        }
      })}
    </div>
  );
};
 